@if (listeEspaces$ | async; as espaces) {
<mat-form-field subscriptSizing="dynamic" [matTooltip]="tooltip() || label()" [ngStyle]="style()">
    <mat-label>{{ label() }}</mat-label>
    <input
        type="text"
        data-tfa="input-espace"
        [required]="required()"
        matInput
        [formControl]="form"
        [matAutocomplete]="auto"
        #trigger="matAutocompleteTrigger"
    />
    @if (form.errors?.invalid) {
    <mat-error>{{ form.errors!.invalid.message }}</mat-error>
    } @if (form.errors?.required) {
    <mat-error>Champ obligatoire</mat-error>
    } @if (!!form.value) {
    <mat-icon matSuffix data-tfa="empty-input-icon_espace" (click)="clear()" class="cursor-pointer">close</mat-icon>
    }
    <mat-autocomplete
        #auto="matAutocomplete"
        data-tfa="autoCompleteEspace"
        [displayWith]="getDisplayValue(espaces)"
        (optionSelected)="selectEspace($event, espaces)"
        role="combobox"
        aria-expanded="false"
        aria-controls="idOptionEspace"
        [panelWidth]="'auto'"
        [hideSingleSelectionIndicator]="true"
    >
        @for (n of listeEspaces$ | async; track n) {
        <mat-option [value]="n.code" class="espace-option" [attr.data-tfa]="'espace_' + n.code" [attr.id]="'espace_' + n.code">
            <div class="option-flex-container">
                <span> {{ n.code }} - {{ n.libelle }}</span>
                <app-espace-chip [espace]="n"></app-espace-chip>
            </div>
        </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
}
<mat-checkbox class="recherche-checkbox" data-tfa="allPeriodes" [checked]="searchPeriodes$ | async" (change)="toggleAllPeriodes()">
    Afficher toutes les périodes
    <mat-icon matTooltip="Présentes, futures, passées et inactives" data-tfa="icon-select-all-periode-info" inline>
        info
    </mat-icon>
</mat-checkbox>
